import { Source } from 'app/constants/import/source'

export const getSource = (inputSource): Source => {
  let source = Source.File

  switch (inputSource) {
    case 1:
      source = Source.Card
      break
  }

  return source
}
